import { Divider, Flex, SegmentedControl, Text } from '@byecode/ui'
import type { SpaceVersion } from '@lighthouse/core'
import React from 'react'
import styled from 'styled-components'

import { SmsPurchase, TrafficPurchase } from './Purchase'
import { SpaceUpgrade } from './SpaceUpgrade'

const TABS = [
    {
        label: '版本升级',
        value: 'version_upgrade'
    },
    {
        label: '增购包',
        value: 'purchase'
    }
]

const StyledContainer = styled.div`
    position: relative;
    width: 100%;
    padding-bottom: 40px;
    /* height: 100%; */
    display: flex;
    flex-direction: column;
    border-radius: inherit;
`

interface UserGradeProps {
    productTab?: 'version_upgrade' | 'purchase'
    onChangeTab?: (v: 'version_upgrade' | 'purchase') => void
    onWechatPaySpaceUpgrade: (level: SpaceVersion) => void
    onWechatPaySms: (order: 'SMS_1000' | 'SMS_5000' | 'SMS_15000') => void
    onWechatPayTraffic: (order: `GB_${number}`) => void
}

const UserGrade: React.FunctionComponent<UserGradeProps> = ({
    productTab = 'version_upgrade',
    onChangeTab,
    onWechatPaySpaceUpgrade,
    onWechatPayTraffic,
    onWechatPaySms
}) => {
    return (
        <StyledContainer>
            <Flex alignItems="center" justifyContent="center" mb={32}>
                <SegmentedControl style={{ width: 252 }} fullWidth size="lg" data={TABS} value={productTab} onChange={onChangeTab} />
            </Flex>

            {productTab === 'version_upgrade' ? (
                <SpaceUpgrade onWechatPaySpaceUpgrade={onWechatPaySpaceUpgrade} />
            ) : (
                <Flex direction="column" gap={32}>
                    <Divider
                        style={{ width: 300, margin: '0 auto' }}
                        label={
                            <Text lineHeight="28px" size={20} color="var(--color-main)" weight={600}>
                                访问流量
                            </Text>
                        }
                    />
                    <TrafficPurchase onWechatPayTraffic={onWechatPayTraffic} />
                    <Divider
                        style={{ width: 300, margin: '0 auto' }}
                        label={
                            <Text lineHeight="28px" size={20} color="var(--color-main)" weight={600}>
                                验证码短信
                            </Text>
                        }
                    />
                    <SmsPurchase onWechatPaySms={onWechatPaySms} />
                </Flex>
            )}
        </StyledContainer>
    )
}

export default UserGrade
